import React from 'react';
import type { CustodyCase } from '../../types/case';
import type { AdminPage, AdminPageProps } from '../../types/navigation';
import { useStore } from '../../contexts/StoreContext';
import { PageHeader } from '../../components/admin/PageHeader';
import { StatusBadge } from '../../components/shared/StatusBadge';
import { ADMIN_MENU } from '../../components/admin/AdminSidebar';
import { isPaid, needsVerification, readyForNote, stageInfo } from '../../utils/caseStatus';
import { bn, fmtDate } from '../../utils/bn';
const FILTERS: Partial<Record<AdminPage, (c: CustodyCase) => boolean>> = {
  verification: needsVerification,
  payments: c => c.stage !== 'registered' && (!isPaid(c) || c.paymentStatus === 'paid'),
  notesheet: c => readyForNote(c) || c.approval === 'pending',
  approval: c => c.approval === 'pending' || c.approval === 'held',
  letters: c => c.approval === 'approved' || !!c.letter,
  handover: c => !!c.letter && (c.letter.status === 'issued' || c.letter.status === 'redeemed')
};

/** Interim queue view: lists the cases relevant to a workflow module and opens their full case record. */
export function WorkQueue({
  page,
  openCase
}: AdminPageProps & {
  page: AdminPage;
}) {
  const {
    cases
  } = useStore();
  const title = ADMIN_MENU.find(m => m.id === page)?.label ?? '';
  const list = cases.filter(FILTERS[page] ?? (() => true));
  return <>
      <PageHeader title={title} crumbs={[title]} description={`${bn(list.length)}টি সংশ্লিষ্ট কেস — বিস্তারিত ও ইতিহাসের জন্য কেস খুলুন`} data-id="element-827" data-mp="5xls4mf5esqp" />
      <div className="card divide-y divide-line" data-id="element-828" data-mp="aukjix7fgll7">
        {list.map(c => {
        const s = stageInfo(c);
        return <button key={c.pcr} onClick={() => openCase(c.pcr)} className="flex w-full items-center justify-between gap-4 px-4 py-3 text-left hover:bg-navy-50" data-id="element-829" data-mp="fp826ffr2lrv">
              <span className="min-w-0" data-id="element-830" data-mp="pmmfw7aagwgh">
                <span className="block font-mono text-sm font-semibold text-navy" data-id="element-831" data-mp="tmmubrxe17nj">{c.pcr}</span>
                <span className="block truncate text-xs text-ink-muted" data-id="element-832" data-mp="2qnaigdysv9e8">{c.regNo} · {c.ownerName} · {fmtDate(c.createdAt)}</span>
              </span>
              <StatusBadge size="sm" label={s.label} tone={s.tone} data-id="element-833" data-mp="2lphdtpd5ang2" />
            </button>;
      })}
        {list.length === 0 && <p className="py-12 text-center text-sm text-ink-muted" data-id="element-834" data-mp="2zhp9tewluadp">এই মুহূর্তে কোনো কেস নেই।</p>}
      </div>
    </>;
}